import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { canAccessAdminPath, firstAllowedAdminPath } from '@/lib/adminSections'

/**
 * R10-15 — guarda das rotas do admin pelo perfil de acesso. Rota fora do perfil vai para a
 * primeira secao liberada (ordem do menu); perfil sem nenhuma secao volta para o app. A API
 * recusa do mesmo jeito (403 `section_forbidden`) — aqui e so para nao abrir tela vazia.
 */
export default function AdminSectionGuard() {
  const user = useAuthStore((state) => state.user)
  const { pathname } = useLocation()

  if (!canAccessAdminPath(user, pathname)) {
    return <Navigate to={firstAllowedAdminPath(user) ?? '/app/dashboard'} replace />
  }

  return <Outlet />
}
